import { Box, Divider, Grid, Paper, Typography, CardHeader, Button, lighten, TextField, Tabs, Tab, IconButton, Tooltip, Chip, useTheme } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import Styles from '../../theme/commonCss/Styles';
import EditSetting from './editSetting';
import EditIconButton from '../../components/EditIconButton';
import { ReactComponent as ResetIcon } from '../../assets/icons/main/restore-icon.svg';
import { SketchPicker } from "react-color";
import { ReactComponent as AlertIcon } from '../../assets/icons/main/alertIcon.svg';
import Popup from '../../components/Popup';
import { connect, useDispatch } from 'react-redux';
import { settingsActions } from '../../store/reducers/settings';
import { get, isEmpty, reduce, template } from 'lodash';
import { matchRoutes, useLocation, useOutletContext } from 'react-router-dom';
import AjvErrors from 'ajv-errors';
import Ajv from 'ajv';
import { defaultColors, defaultColorsLabels, defaultColorsTooltip, defaultPageSetting, defaultTextFields, thmeShema } from './form';
import { ReactComponent as CloseIcon } from '../../assets/icons/main/close-icon.svg';
import { ReactComponent as VrLine } from '../../assets/icons/main/verticalLine.svg';
import { ReactComponent as EditIcon } from '../../assets/icons/main/create-icon.svg';
import { ReactComponent as SaveIcon } from '../../assets/icons/main/save-icon.svg';
import { ReactComponent as EyeIcon } from '../../assets/icons/main/eye-icon.svg';
// import { routePaths } from '../../utils/route-paths';
import DropzoneComponent from './fileUpload';
import { ReactComponent as InfoOutlined } from '../../assets/icons/main/info-icon.svg';
import { palette } from '../../theme/palette';
import { ReactComponent as MainLogo } from '../../assets/icons/main/logo.svg';
import { ReactComponent as SmallLogo } from '../../assets/icons/main/logo_small.svg';
import { ReactComponent as FaviconLogo } from '../../assets/icons/main/iotinbox_favicon.svg';
import { ReactComponent as ThemeIcon } from '../../assets/icons/main/palette-icon.svg';
import Snackbar from '../../common/snackBar';


/**
 * Tab config to initialize the tab and perform tab selection
 */
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
const tabList = ['Labels', 'Theme']
function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}
function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
/**Tab config ends here */
/**
 * The main component initialization
 * @param param0 settingsData, isSettingsAddSuccess, userAccess from state
 * @returns JSX elements
 */
function Settings({ settingsData, isSettingsAddSuccess, userAccess }: any) {
   const routePaths: any = get(useOutletContext(), 'combinedRoutePaths', [])
  const ajv = new Ajv({ allErrors: true });
  AjvErrors(ajv);
  const { pathname } = useLocation();
  const matchedRoute = matchRoutes(routePaths, pathname);
  const hasAccessTo = get(userAccess, `${get(matchedRoute, '[0].route.endPointPath', '')}`, {});
  const themeData: any = useTheme();
    
  const validate = ajv.compile(thmeShema);
  const [ajvErrors, setAjvErrors] = useState<any>({});
  const [pageSettings, setPageSettings] = useState<any>(defaultPageSetting)
  const [colorModal, setColorModal] = useState<any>({ isOpen: false, selectedTitle: '' })
  const dispatch = useDispatch();
  const [pageEditSelection, setPageEditSelection] = useState<any>({})
  const [popupText, setPopupText] = useState<any>({ title: '', isConfirmOpen: false, reqType: '', data: {} })
  const [isResetDisabled, setIsResetDisabled] = useState<any>(true);
  const themeMode: any = get(useOutletContext(), 'themeMode', {});
  const styles: any = {
    box: {
      margin: '24px',
      boxShadow: '0px 0px 14px 0px #0000000D',
      borderRadius: '18px',
      border: `1px solid ${themeData.palette.customBorderColor.main}`,
      height: 'auto',
      padding: '24px',
    },
    logocontainer: { display: 'flex', flexDirection: 'column', padding: '24px' },
    logoimage: { display: 'flex', justifyContent: 'center', paddingTop: '39px' }
  };

  // useEffect(()=>{
  //   dispatch(settingsActions.getSettingsDataRequest(''));
  // },[])

  /**
   * Here we are checking is data is available in theme config or not
   * if YES - load it from theme config
   * if NO - load it from default config constant
   * we are checking & comparing each and every properties from config data (settingsData) & default config data (defaultConfigData)
   * pageSettings array is  our main array in which we are doing changes
   */
  useEffect(() => {
    const _settingsData = get(settingsData, 'config', {});
    const _local_def = get(defaultPageSetting, 'config', {});
    let _temp: any = {};

    for (let data in _local_def) {
      if (_settingsData[data]) {
        if (defaultTextFields[data]) {
          if (data === 'font_changes') {
            _temp = { ..._temp, [data]: { font_name: isEmpty(_settingsData[data]['font_name']) ? _local_def[data]['font_name'] : _settingsData[data]['font_name'], cdn_url: isEmpty(_settingsData[data]['cdn_url']) ? _local_def[data]['cdn_url'] : _settingsData[data]['cdn_url'] } }
          } else {
            _temp = { ..._temp, [data]: { entity_name: isEmpty(_settingsData[data]['entity_name']) ? _local_def[data]['entity_name'] : _settingsData[data]['entity_name'], page_name: isEmpty(_settingsData[data]['page_name']) ? _local_def[data]['page_name'] : _settingsData[data]['page_name'] } }
          }
        } else {
          _temp = { ..._temp, [data]: isEmpty(_settingsData[data]) ? _local_def[data] : _settingsData[data] }
        }
      } else {
        if (defaultTextFields[data]) {
          if (data === 'font_changes') {
            _temp = { ..._temp, [data]: { font_name: _local_def[data]['font_name'], cdn_url: _local_def[data]['cdn_url'] } }
          } else {
            _temp = { ..._temp, [data]: { entity_name: _local_def[data]['entity_name'], page_name: _local_def[data]['page_name'] } }
          }
        } else {
          _temp = { ..._temp, [data]: _local_def[data] }
        }

      }
    }
    setPageSettings(_temp)
  }, [settingsData])

  /**
   * Here we are setting our state to represet edit, reset
   * this code block is also responsible for save button enable/disable
   */
  useEffect(() => {
    if (!isEmpty(defaultTextFields)) {
      let _tempEditData = {};
      Object.keys(defaultTextFields).forEach((item: any) => {
        _tempEditData = { ..._tempEditData, [item]: false, [item + '_' + 'reset']: false }
      })
      setPageEditSelection(_tempEditData)
    }
  }, [defaultTextFields])
  /**
  * Here we are setting our state to represet edit, reset
  * this code block is also responsible for save button enable/disable
  */
  const isLabelSaveDisabled = useMemo(() => {
    const pageKeys = Object.keys(defaultTextFields);
    return pageKeys.some((item: any) => {
      return pageEditSelection[item + '_' + 'reset'] === true || pageEditSelection[item] === true
    })
  }, [pageEditSelection])
  /**
    * Here we are checking is data saved successfully
    * if YES - calling the api to load the updated values
    */
  useEffect(() => {
    if (isSettingsAddSuccess) {
      dispatch(settingsActions.getSettingsDataRequest(''));
    }

    return () => {
      dispatch(settingsActions.resetSettings())
    }
  }, [isSettingsAddSuccess])

  /**
   *Popup for the color change in theme config
   *Including open and close functions defined below
   */
  const renderModal = () => (
    <EditSetting
      pageSettings={pageSettings}
      isOpen={colorModal.isOpen}
      handleClose={closeColorModal}
      setPageSettings={setPageSettings}
      selectedTheme={colorModal.selectedTitle}
    />
  );
  const openModal = (item: any) => {
    if (!hasAccessTo.create || !hasAccessTo.update) {
      Snackbar.info('You dont have permission')
    } else {
      setColorModal({
        isOpen: true,
        selectedTitle: item
      })
    }

  }
  const closeColorModal = () => {
    setColorModal({
      isOpen: false,
      selectedTitle: ''
    })
  };
  /**
   * Text field value update based on the selected property in object
   * @param event input event
   * @param item keys present in the object [things_machine...]
   */
  const handleChange = (event: any, item: any) => {
    const { name, value } = event.target;
    setPageSettings({ ...pageSettings, [item]: { ...pageSettings[item], [name]: value } })
  }
  /**
   * Method used to change color only
   * @param type here type is for multiple usage of below method, like reset_to_def etc
   */
  const colorChangeActions = (type: any) => {
    if (type === 'reset_to_default') {
      setPopupText({ title: 'Are you sure you want to reset the theme to its default settings?', isConfirmOpen: true, reqType: type })
    } else if (type === 'reset') {
      setIsResetDisabled(true)
      dispatch(settingsActions.getSettingsDataRequest(''));
    } else {
      setIsResetDisabled(false)
      setPopupText({ title: 'The preview theme will be applied throughout the application but will be lost after the page is reloaded.', isConfirmOpen: true, reqType: type })
    }
  }
  /**
   * We are calling this method to handle the confirm actions on click of Yes/No,
   * @param reqType reset_to_default,preview,label,color
   * @param type confirm, close
   * @param data payload if any
   * calling api whenever required
   */
  const handleActions = (reqType: any, type: any, data: any) => {
    if (type === 'confirm') {
      if (reqType === 'reset_to_default') {
        const data: any = {
          config: {
            ...pageSettings,
            ...defaultColors
          }
          , status: 'saved'
        }
        dispatch(settingsActions.addSettingsRequest(data))
        setPopupText({ title: '', isConfirmOpen: false, reqType: '', data: {} })
      } else if (reqType === 'preview') {
        const data: any = {
          config: {
            ...pageSettings,
          }
          , status: 'saved'
        }
        dispatch(settingsActions.makepreview(data))
        setPopupText({ title: '', isConfirmOpen: false, reqType: '', data: {} })
      } else if (reqType === 'label' || reqType === 'color') {
        handleSubmit(data.payLoad, data.page_name)
      }
    } else if (type === 'warning') {
      setPopupText({ title: '', isConfirmOpen: false, reqType: '', data: {} })
    }
  };
  /**
   * Here we are opening the confirm popup to validate the lable related api call
   * @param event input event
   * @param page_name object key like things_machine, things_parts etc
   * @param reqType label change, color change
   */
  const submitConfirm = (event: any, page_name: any, reqType: any) => {
    event.preventDefault();
    if (validate({ ...pageSettings })) {
      const payLoad: any = { config: { ...pageSettings }, status: 'saved' }
      setPopupText({ title: `Are you sure you want to save ${reqType} changes?`, isConfirmOpen: true, reqType: reqType, data: { payLoad: payLoad, page_name: page_name } })
      setAjvErrors({})
    } else {
      if (validate.errors) {
        // console.log(validate.errors)
        setAjvErrors(validate.errors[0]);
      }
    }
  }
  /**
   * This method is used to save label related changes
   * @param payLoad payload to be sent
   * @param page_name keys of pageSettingsData
   */
  const handleSubmit = (payLoad: any, page_name: any) => {
    dispatch(settingsActions.addSettingsRequest(payLoad))
    setPopupText({ title: '', isConfirmOpen: false, reqType: '', data: {} })
    if (page_name) {
      setPageEditSelection({ ...pageEditSelection, [page_name]: false })
    }
  }
  /**
   * Tab Related Config
   */
  const [value, setValue] = useState(0);
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  /**
   * Method helps to enable textbox to edit
   * @param page_name object key like things_machine, things_parts etc
   * It also enables the save button
   */
  const onEditClick = (page_name: any) => {
    setPageEditSelection({ ...pageEditSelection, [page_name]: true, [page_name + '_' + 'reset']: false })
  }
  /**
   * Method helps to get the default values of particular section
   * @param page_name object key like things_machine, things_parts etc
   * It also enables the save button
   */
  const onResetClick = (page_name: any) => {
    setPageSettings({ ...pageSettings, [page_name]: { ...defaultPageSetting['config'][page_name] } })
    setPageEditSelection({ ...pageEditSelection, [page_name]: true, [page_name + '_' + 'reset']: true })
  }
  /**
   * Method helps to close the edit selection
   * @param page_name object key like things_machine, things_parts etc
   * It also disables the save button
   */
  const onCloseClick = (page_name: any) => {
    setPageEditSelection({ ...pageEditSelection, [page_name]: false, [page_name + '_' + 'reset']: false })
  }

  return (
    <>
      <Box sx={Styles.masterContainer}>
        <Paper sx={{ ...Styles.masterPaperContainer, minHeight: 'calc(100vh - 210px)', paddingBottom: '24px', width: '100%', backgroundColor: (themeMode.isLightBG) ? lighten(themeData.palette.background.default, 0.9) : lighten(themeData.palette.background.default, 0.05), color: themeData.palette.text.primary }}>
          <Box sx={{ padding: '32px', borderBottom: `1px solid ${themeData.palette.customBorderColor.main}` }}>
            <Typography variant='h2'>
              Appearance
            </Typography>
          </Box>
          <Box sx={{ borderBottom: `1px solid ${themeData.palette.customBorderColor.main}` }}>
            <Grid container spacing={2}>
              <Grid item lg={4} md={4} xs={12} sm={12}>
                <Tabs value={value} onChange={handleTabChange} aria-label="basic tabs example" sx={{
                  '& .MuiTabs-scroller': { paddingLeft: '32px', },
                }}>
                  {tabList.map((item: any, index: number) => (<Tab key={index} label={item} {...a11yProps(index)} />))}
                </Tabs>
              </Grid>
              <Grid item lg={8} md={8} xs={12} sm={12} sx={{ display: 'flex', justifyContent: 'flex-end', paddingRight: '32px', alignItems: 'center'}} >
                {
                  (value === 1) && <>
                    <Grid item sx={{
                      display: 'flex', flexWrap: 'wrap', flexDirection: 'row', gap: '16px', justifyContent: 'flex-end', alignItems: 'center', 
                      '@media (min-width:1201px)': {
                        flexWrap: 'no-wrap',
                        gap: '16px',
                      },
                      '@media (min-width:300px) and (max-width:1400px)': {
                        paddingBottom: '16px',
                        gap: '16px',
                      },
                      '@media (min-width:900px) and (max-width:1400px)': {
                        marginTop: '16px',
                      },
                      '@media (min-width:300px) and (max-width:1199px)': {
                        width: '100%',
                      },

                    }}>
                      <Button variant='outlined' type='submit' disabled={!hasAccessTo.create || !hasAccessTo.update} onClick={(event: any) => { colorChangeActions('reset_to_default') }}><ThemeIcon /> Reset to default theme</Button>
                      <Button variant='outlined' type='submit' disabled={!hasAccessTo.create || !hasAccessTo.update || isResetDisabled} onClick={(event: any) => { colorChangeActions('reset') }}><ResetIcon /> Reset to previous</Button>
                      <Button variant='outlined' type='submit' onClick={(event: any) => { colorChangeActions('preview') }}><EyeIcon /> Preview</Button>
                      <Button variant='contained' type='submit' disabled={!hasAccessTo.create || !hasAccessTo.update} onClick={(event: any) => { submitConfirm(event, '', 'color') }} ><SaveIcon />Save</Button>
                    </Grid>
                  </>
                }

                {
                  (value === 0) && <>
                  <Grid item sx={{
                  '@media (max-width:900px)': {
                    marginBottom: '16px',
                  },
                  }}>
                   <Button variant='contained' type='submit' disabled={!hasAccessTo.create || !hasAccessTo.update || !isLabelSaveDisabled} onClick={(event: any) => { submitConfirm(event, '', 'label') }} ><SaveIcon /> Save</Button>
                  </Grid>
                  </>
                }
              </Grid>
            </Grid>

          </Box>

          <CustomTabPanel value={value} index={0}>
            {!isEmpty(pageSettings) ? Object.keys(pageSettings).filter((item: any) => item != "primary_color" && item != "secondary_color" && item != "background_color" && item != 'text_color' && item != 'font_changes').map((item: any) => (
              <Grid container>
                <Grid xs={12} sx={{ padding: '24px 32px', display: 'flex', flexDirection: 'row', alignItems: 'center', backgroundColor: (themeMode.isLightBG) ? lighten(themeData.palette.background.default, 0.2) : lighten(themeData.palette.background.default, 0.08), borderBottom: `1px solid ${themeData.palette.customBorderColor.main}` }} >
                  <Grid xs={10} >
                    <Typography variant='h4' sx={{ paddingBottom: '0px', fontWeight: '600' }} >{`Default Name : ${get(defaultTextFields, item, '')}`}</Typography>
                  </Grid>
                  <Grid xs={2} display={'flex'} flexDirection={'row'} justifyContent={'flex-end'} >
                    <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row', justifyContent: 'flex-end' }}>
                      {!pageEditSelection[item] ?
                        <IconButton disabled={!hasAccessTo.create || !hasAccessTo.update} onClick={() => { onEditClick(item) }} > <EditIcon style={{ color: themeData.palette.custom.light }} /></IconButton>
                        : <IconButton disabled={!hasAccessTo.create || !hasAccessTo.update} onClick={(event: any) => { onCloseClick(item) }}> <CloseIcon style={{ color: themeData.palette.custom.light }} /></IconButton>
                      }
                      <VrLine style={{ height: '24px', color: themeData.palette.customBorderColor.main }} />
                      <IconButton onClick={() => { onResetClick(item) }}>
                        <Tooltip
                          title={
                            <Typography variant='subtitle1' sx={{ padding: '8px', fontSize: '0.9rem' }}>
                              Click to get default label values.
                            </Typography>
                          }
                          arrow
                          placement='right'
                        >
                          <ResetIcon style={{ color: themeData.palette.custom.light }} />
                        </Tooltip>
                      </IconButton>
                    </Box>

                  </Grid>

                </Grid>
                <Grid container sx={{ padding: '16px 32px', display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', borderBottom: `1px solid ${themeData.palette.customBorderColor.main}` }}>
                  <Grid item xs={6} sm={5} md={3} lg={2}>
                    <Typography sx={{ ...Styles.inputLabel, textAlign: 'right', color: themeData.palette.text.secondary }} variant='subtitle1'>{(item === 'font_changes') ? 'Font Name :' : 'Entity Name :'}</Typography>
                  </Grid>
                  <Grid item xs={6} sm={5} md={4} lg={3} >
                     <TextField margin='normal' fullWidth variant='outlined' size='small'
                      name={(item === 'font_changes') ? 'font_name' : 'entity_name'}
                      value={get(pageSettings[item], (item === 'font_changes') ? 'font_name' : 'entity_name', pageSettings[item])}
                      onChange={(event: any) => handleChange(event, item)}
                      helperText={ajvErrors.instancePath && ajvErrors.instancePath.includes(item + '/entity_name') && ajvErrors.message}
                      error={ajvErrors.instancePath && ajvErrors.instancePath.includes(item + '/entity_name')}
                      InputProps={{
                        readOnly: !get(pageEditSelection, item, false),
                      }}
                      sx={{
                        "&.MuiFormControl-root": {
                          marginTop: '0px',
                          marginBottom: '0px'
                        },
                        "&:has([readonly]) ": {
                          '& .MuiInputBase-root': {
                            backgroundColor: (themeMode.isLightBG) ? palette.disabledColor.light : palette.disabledColor.dark,
                          },
                          '& .MuiInputBase-input': {
                            fontSize: '1rem',
                            color: palette.info.dark,
                            fontWeight: '400',
                          },
                          '& .MuiInput-root:before': {
                            borderBottom: 'none',
                          },
                          '& .MuiInput-root:after': {
                            borderBottom: 'none',
                          },
                          '&::hover': {
                            border: 'none',
                          },
                        },
                      }}
                    />
                  </Grid>
                  <Grid item>
                    <IconButton>
                      <Tooltip
                        title={
                          <Typography variant='subtitle1' sx={{ padding: '16px' }}>
                            The entity name should not affect the column's structure;
                            it only changes the type of page it represents.
                            You can also modify the page name, which will be used in the menu list and page headings.
                          </Typography>
                        }
                        arrow
                        placement='right'
                      >
                        <InfoOutlined style={{ color: themeData.palette.custom.light }} />
                      </Tooltip>
                    </IconButton>
                  </Grid>
                </Grid>
                <Grid container xs={12} sx={{ padding: '16px 32px', display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', backgroundColor: (themeMode.isLightBG) ? lighten(themeData.palette.background.default, 0.9) : lighten(themeData.palette.background.default, 0.05), borderBottom: `1px solid ${themeData.palette.customBorderColor.main}` }}>
                  <Grid item xs={6} sm={5} md={3} lg={2}>
                    <Typography sx={{ ...Styles.inputLabel, textAlign: 'right', color: themeData.palette.text.secondary }} variant='subtitle1' >{(item === 'font_changes') ? 'CDN URL :' : 'Page Name :'}</Typography>
                  </Grid>
                  <Grid item xs={6} sm={5} md={4} lg={3} >
                    <TextField margin='normal' fullWidth variant='outlined' name={(item === 'font_changes') ? 'cdn_url' : 'page_name'}
                      value={get(pageSettings[item], (item === 'font_changes') ? 'cdn_url' : 'page_name', '')}
                      onChange={(event: any) => handleChange(event, item)} size='small'
                      helperText={ajvErrors.instancePath && ajvErrors.instancePath.includes(item + '/page_name') && ajvErrors.message}
                      error={ajvErrors.instancePath && ajvErrors.instancePath.includes(item + '/page_name')}

                      InputProps={{
                        readOnly: !get(pageEditSelection, item, false),
                      }}
                      sx={{
                        "&.MuiFormControl-root": {
                          marginTop: '0px',
                          marginBottom: '0px'
                        },
                        "&:has([readonly]) ": {
                          '& .MuiInputBase-root': {
                            backgroundColor: (themeMode.isLightBG) ? palette.disabledColor.light : palette.disabledColor.dark,
                          },
                          '& .MuiInputBase-input': {
                            fontSize: '1rem',
                            color: palette.info.dark,
                            fontWeight: '400',
                          },
                          '& .MuiInput-root:before': {
                            borderBottom: 'none',
                          },
                          '& .MuiInput-root:after': {
                            borderBottom: 'none',
                          },
                          '&:hover': {
                            border: 'none',
                          },
                        },
                      }}
                    />
                  </Grid>
                  <Grid item >
                    <IconButton>
                      <Tooltip
                        title={
                          <Typography variant='subtitle1' sx={{ padding: '16px' }}>
                            The page name only changes the menu list & page heading of page it represents.
                          </Typography>
                        }
                        arrow
                        placement='right'
                      >
                        <InfoOutlined style={{ color: themeData.palette.custom.light }} />
                      </Tooltip>
                    </IconButton>
                  </Grid>
                </Grid>
              </Grid>
            )) : <></>}
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <Grid container>
              {['background_color', 'primary_color', 'secondary_color', 'text_color'].map((item: any, index: number) => (
                <Grid item xs={12} sx={{
                  padding: '16px 32px', display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
                  backgroundColor: (themeMode.isLightBG) ? ((index + 1) % 2 == 0) ? lighten(themeData.palette.background.default, 0.9) : lighten(themeData.palette.background.default, 0.2)
                    : ((index + 1) % 2 == 0) ? lighten(themeData.palette.background.default, 0.05) : lighten(themeData.palette.background.default, 0.08)
                }}>
                  <Grid item xs={6} md={4} lg={3}>
                    <Typography variant='h3' sx={{ ...Styles.inputLabel, textAlign: 'right', textTransform: 'capitalize', color: themeData.palette.text.secondary }}>{defaultColorsLabels[item]}</Typography>
                  </Grid>
                  <Grid item xs={3} md={2} lg={2}>
                    <TextField margin='normal' fullWidth variant='outlined' size='small'
                      name={item}
                      value={get(pageSettings, item, '')}
                      onChange={(event: any) => handleChange(event, item)}
                      InputProps={{
                        readOnly: true
                      }}
                      sx={{
                        "&.MuiFormControl-root": {
                          marginTop: '0px',
                          marginBottom: '0px'
                        },
                        "&:has([readonly]) ": {
                          '& .MuiInput-input': {
                            fontSize: '1rem',
                            color: '#64759F',
                            fontWeight: '400',
                          },

                          // '& .MuiInput-root:before': {
                          //   borderBottom: 'none',
                          // },
                          // '& .MuiInput-root:after': {
                          //   borderBottom: 'none',
                          // },
                          // '&::hover': {
                          //   border: 'none',
                          // },
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={4} sx={{ display: 'flex', cursor: 'pointer', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center' }}>
                    <Box sx={{ height: '42px', width: '42px', borderRadius: '8px', backgroundColor: pageSettings[item], border: `1px solid ${themeData.palette.customBorderColor.main}`, marginLeft: '28px', marginRight: '20px', curson: 'pointer' }} onClick={() => openModal(item)}></Box>
                    <IconButton>
                      <Tooltip
                        title={
                          <Typography variant='subtitle1' sx={{ padding: '16px' }}>
                            {defaultColorsTooltip[item]}
                          </Typography>
                        }
                        arrow
                        placement='right'
                      >
                        <InfoOutlined style={{ color: themeData.palette.custom.light }} />
                      </Tooltip>
                    </IconButton>
                  </Grid>
                </Grid>
              ))}
            </Grid>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <Grid container>
              <Grid xs={12} sx={{ padding: '24px 32px', display: 'flex', flexDirection: 'row', alignItems: 'center', backgroundColor: lighten(themeData.palette.background.default, 0.8), borderBottom: `1px solid ${themeData.palette.customBorderColor.main}` }} >
                <Grid item xs={4}>
                  <Typography sx={{ paddingBottom: '0px', display: 'flex', justifyContent: 'center' }} >Example</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography sx={{ paddingBottom: '0px', display: 'flex', justifyContent: 'center' }} >Upload</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography sx={{ paddingBottom: '0px', display: 'flex', justifyContent: 'center' }} >Preview</Typography>
                </Grid>
              </Grid>
              <Grid xs={12} sx={{ display: 'flex', flexDirection: 'row', backgroundColor: lighten(themeData.palette.background.default, 0.8), borderBottom: `1px solid ${themeData.palette.customBorderColor.main}` }} >
                <Grid item xs={4} sx={styles.logocontainer}>
                  <Box>
                    <Chip label='Logo' color='primary' variant='outlined' />
                  </Box>
                  <Box sx={styles.logoimage}>
                    <MainLogo />
                  </Box>
                </Grid>
                <Grid item xs={4}>
                  <DropzoneComponent />
                </Grid>
                <Grid item xs={4}>
                  <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row', justifyContent: 'flex-end' }}>
                    <IconButton><ResetIcon style={{ color: themeData.palette.custom.light }} /></IconButton>
                  </Box>
                </Grid>
              </Grid>

              <Grid xs={12} sx={{ display: 'flex', flexDirection: 'row', backgroundColor: lighten(themeData.palette.background.default, 0.8), borderBottom: `1px solid ${themeData.palette.customBorderColor.main}` }} >
                <Grid item xs={4} sx={styles.logocontainer}>
                  <Box>
                    <Chip label='Logo Symbol' color='primary' variant='outlined' />
                  </Box>
                  <Box sx={styles.logoimage}>
                    <SmallLogo />
                  </Box>
                </Grid>

                <Grid item xs={4} >
                  <DropzoneComponent />
                </Grid>
                <Grid item xs={4} >
                  <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row', justifyContent: 'flex-end' }}>
                    <IconButton><ResetIcon style={{ color: themeData.palette.custom.light }} /></IconButton>
                  </Box>
                </Grid>
              </Grid>

              <Grid xs={12} sx={{ display: 'flex', flexDirection: 'row', backgroundColor: lighten(themeData.palette.background.default, 0.8), borderBottom: `1px solid ${themeData.palette.customBorderColor.main}` }} >
                <Grid item xs={4} sx={styles.logocontainer}>
                  <Box>
                    <Chip label='Favicon' color='primary' variant='outlined' />
                  </Box>
                  <Box sx={styles.logoimage}>
                    <FaviconLogo />
                  </Box>
                </Grid>
                <Grid item xs={4}>
                  <DropzoneComponent />
                </Grid>
                <Grid item xs={4}>
                  <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row', justifyContent: 'flex-end' }}>
                    <IconButton><ResetIcon style={{ color: themeData.palette.custom.light }} /></IconButton>
                  </Box>
                </Grid>
              </Grid>

            </Grid>

          </CustomTabPanel>
        </Paper>
      </Box>
      {popupText.isConfirmOpen && <Popup
        open={popupText.isConfirmOpen}
        icon={<AlertIcon color={palette.warning.main} />}
        message={popupText.title}
        cancel={true}
        confirmation={true}
        cancelLabel='No'
        confirmLabel='Yes'
        onConfirm={() => handleActions(popupText.reqType, 'confirm', popupText.data)}
        onClose={() => handleActions('', 'warning', {})}
        onCancel={() => handleActions('', 'warning', {})}
      />}
      {colorModal.isOpen && renderModal()}
    </>
  );
}

const mapStateToProps = (state: any) => ({
  settingsData: state.settings.settingsData,
  isSettingDataLoading: state.settings.isSettingsDataLoading,
  isSettingsAddSuccess: state.settings.isSettingsAddSuccess,
  userAccess: state.profile.userAccess,
});

export default connect(mapStateToProps)(Settings);
